import type { UserLoginByPasswordInput } from '../../../base-api/Api'
import { api } from '../../api'

export const userLoginByPassword = async (data: UserLoginByPasswordInput) => {
  return await api.v1.userLoginByPassword(data)
}
